import { toValue } from "vue";
export const getTabbableElements = (element) => {
    const root = toValue(element);
    if (!root || !(root instanceof HTMLElement)) {
        console.warn("getTabbableElements: invalid element", root);
        return [];
    }
    return Array.from(root.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), [contenteditable]')).filter((el) => {
        if (el.hasAttribute("disabled") || el.getAttribute("aria-hidden") === "true") {
            return false;
        }
        // Traverse up to `root`, stopping early if a fixed/absolute container is found
        let current = el;
        while (current && current !== root) {
            const style = window.getComputedStyle(current);
            if (style.position === "fixed") {
                return false;
            }
            current = current.parentElement;
        }
        return true;
    });
};
// Keyboard navigation
export const focusSiblingElement = (navigationScope, // Array of elements to navigate through
activeElement, step) => {
    const scope = toValue(navigationScope);
    const active = toValue(activeElement);
    const elements = scope.flatMap(getTabbableElements);
    if (!scope.length || !active)
        return;
    // Get the index of the currently focused element
    const currentIndex = elements.indexOf(active);
    // helper function to focus an element by index
    const focusElement = (index) => {
        const element = elements[index];
        if (element) {
            element.focus();
        }
    };
    // Calculate the next index using modular arithmetic to wrap around the array
    const index = (currentIndex + step + elements.length) % elements.length;
    focusElement(index);
};
export const focusNextElement = (navigationScope, // Array of elements to navigate through
activeElement) => focusSiblingElement(navigationScope, activeElement, 1);
export const focusPreviousElement = (navigationScope, // Array of elements to navigate through
activeElement) => focusSiblingElement(navigationScope, activeElement, -1);
